<template>
<div class="">
    <div>
        <ol class="breadcrumb fs-sm mb-1">
            <li class="breadcrumb-item">
                <router-link to="/dashboard">Dashboard</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Suppliers</li>
        </ol>
        <h4 class="main-title mb-2">Suppliers</h4>
    </div>
    <div class="row">
        <div class="col-4" v-can="'suppliers.create'">
            <form @submit.prevent="submitForm()">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title" v-if="status">New Supplier</h6>
                        <h6 class="card-title" v-else>Update Supplier</h6>
                    </div>
                    <div class="card-body">
                        <div class="row g-2">
                            <div class="col-md-12">
                                <label class="form-label">Supplier Code</label><span class="text-danger"> *</span>
                                <input type="text" placeholder="Supplier Code" :class="{ 'is-invalid': errors.supplier_code }" class="form-control" v-model="supplier.supplier_code" ref="supplier_code" />
                                <span v-if="errors.supplier_code"><small class="text-danger">{{ errors.supplier_code[0] }}</small></span>
                            </div>
                            <div class="col-md-12">
                                <label class="form-label">Supplier Name</label><span class="text-danger"> *</span>
                                <input type="text" placeholder="Supplier Name" :class="{ 'is-invalid': errors.supplier_name }" class="form-control" v-model="supplier.supplier_name" />
                                <span v-if="errors.supplier_name"><small class="text-danger">{{ errors.supplier_name[0] }}</small></span>
                            </div>
                            <div class="col-md-12">
                                <label class="form-label">Location</label><span class="text-danger"> *</span>
                                <input type="text" placeholder="Location" :class="{ 'is-invalid': errors.location }" class="form-control" v-model="supplier.location" />
                                <span v-if="errors.location"><small class="text-danger">{{ errors.location[0] }}</small></span>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-end">
                        <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                        <button method="submit" class="btn btn-primary">
                            <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                            <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div :class="column">
            <div class="card card-one">
                <div class="card-header d-flex justify-content-between">
                    <h6 class="card-title">Suppliers</h6>
                </div>
                <div class="card-body">
                    <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                    <div class="table-responsive table-responsive-sm">
                        <table class="table table-sm table-striped text-nowrap table-bordered mb-0">
                            <thead>
                                <tr style="background-color: #9b9b9b; color: white;">
                                    <th class="text-center">#</th>
                                    <th @click="sort('supplier_code')">
                                        Supplier Code
                                        <span>
                                            <i v-if="meta.keyword=='supplier_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                            <i v-else-if="meta.keyword=='supplier_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <th @click="sort('supplier_name')">
                                        Supplier Name
                                        <span>
                                            <i v-if="meta.keyword=='supplier_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                            <i v-else-if="meta.keyword=='supplier_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <th @click="sort('location')">
                                            Location
                                            <span>
                                                <i v-if="meta.keyword=='location' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='location' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                    </th>
                                    <th class="text-center" v-can="'suppliers.delete'">Status</th>
                                    <th class="text-center" v-can="'suppliers.update'">Actions</th>
                                </tr>

                            </thead>
                            <tbody>
                                <tr v-if="suppliers.length==0">
                                    <td colspan="6" class="text-center">No records found</td>
                                </tr>
                                <tr v-for="supplier, key in suppliers" :key="key">
                                    <td class="text-center">{{ meta.from + key }}</td>
                                    <td>{{ supplier.supplier_code }}</td>
                                    <td>{{ supplier.supplier_name }}</td>
                                     <td>{{ supplier.location }}</td>
                                    <td class="text-center" v-can="'suppliers.delete'">
                                        <div class="form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="'supplier' + supplier.supplier_id" :checked="supplier.status" :value="supplier.status" @change="deleteSupplier(supplier)" />
                                            <label class="custom-control-label" :for="'supplier' + supplier.supplier_id"></label>
                                        </div>
                                    </td>
                                    <td class="text-center" v-can="'suppliers.update'">
                                        <a href="javascript:void(0)" v-if="supplier.status" class="text-success me-2" @click="editSupplier(supplier)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="d-flex justify-content-between align-items-center">
                        <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>
                            <option>25</option>
                            <option>30</option>
                        </select>
                        <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                        <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
export default {
    components: {
        Pagination,
    },
    data() {
        return {
            column: '',
            meta: {
                search: "",
                order_by: "asc",
                keyword: "supplier_id",
                per_page: 10,
                totalRows: 0,
                page: 1,
                lastPage: 1,
                from: 1,
                to: 1,
                maxPage: 1,
                trashed: false,
            },
            supplier: {
                supplier_id: "",
                supplier_code: "",
                supplier_name: "",
                location: "",

            },
            status: true,
            suppliers: [],
            errors: [],
        };
    },
    mounted() {
        this.create_supplier = this.$store.getters.permissions.filter(function (element) {
            return element.ability.ability.includes('suppliers.create')
        })
        if (this.create_supplier.length) {
            this.column = 'col-8'
        } else {
            this.column = 'col-12'
        }
        this.index();
    },

    methods: {
        submitForm() {
            let vm = this;
            if (vm.status) {
                vm.addSupplier();
            } else {
                vm.updateSupplier();
            }
        },
        index() {
            let vm = this;
            vm.$store
                .dispatch("post", {
                    uri: "paginateSuppliers",
                    data: vm.meta
                })
                .then((response) => {
                    vm.suppliers = response.data.data;
                    vm.meta.totalRows = response.data.meta.total;
                    vm.meta.lastPage = response.data.meta.last_page;
                    vm.meta.from = response.data.meta.from;
                    vm.meta.to = response.data.meta.to;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        addSupplier() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", {
                    uri: "addSupplier",
                    data: vm.supplier
                })
                .then((response) => {
                    loader.hide();
                    vm.$store.dispatch("success", "Supplier Added successfully");
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        updateSupplier() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", {
                    uri: "updateSupplier",
                    data: vm.supplier
                })
                .then((response) => {
                    loader.hide();
                    vm.$store.dispatch("success", "Supplier is successfully updated");
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        editSupplier(supplier) {
            let vm = this;
            vm.$refs.supplier_code.focus();
            vm.errors = [];
            vm.status = false;
            vm.supplier = supplier;
        },

        deleteSupplier(supplier) {
            let vm = this;
            let loader = vm.$loading.show();
            supplier.status = supplier.status == 1 ? 0 : 1;
            vm.$store
                .dispatch("post", {
                    uri: "deleteSupplier",
                    data: supplier
                })
                .then(function (response) {
                    loader.hide();
                    vm.$store.dispatch("success", response.data.message);
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        search() {
            let vm = this;
            vm.meta.page = 1;
            vm.index();
        },

        onPageChange(page) {
            let vm = this;
            vm.meta.page = page;
            vm.index();
        },
        sort(field) {
            let vm = this;
            vm.meta.keyword = field;
            vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
            vm.index();
        },
        discard() {
            let vm = this;
            vm.supplier.supplier_code = "";
            vm.supplier.supplier_name = "";
            vm.supplier.location= "";
            vm.$refs.supplier_code.focus();
            vm.errors = [];
            vm.status = true;
            vm.index();
        },
        onPerPageChange() {
            this.meta.page = 1;
            this.index();
        },
    },
};
</script>
